import { getComplianceData } from '../Apps/ContactCenter/Api/api';
import { isCustomerFromCalifornia } from './utils';

interface BannerResponse {
    isCaliforniaCustomer: boolean
    displayBanner: boolean
    displayText: string
}

/**
 * Checks if a banner should be displayed for a customer
 * If customer is from California, returns true
 * If not from California, makes a compliance API call to check if banner should be displayed
 * @param customerPostalCode - Customer's postal/zip code
 * @param countryCode - Customer's country code (required for non-California customers)
 * @returns Promise<boolean> - true if banner should be displayed, false otherwise
 */

export const shouldDisplayBanner = async (
  conversationId: string,
  customerPostalCode: string, 
  countryCode?: string
): Promise<BannerResponse> => {

  // Check if customer is from California 
  if (isCustomerFromCalifornia(customerPostalCode)) {
    return {
        isCaliforniaCustomer: true,
        displayBanner: true,
        displayText: `California based customer. Give customer assurance of cancellation before pitching any save offers. Use 'California Cancel' PDC.`
      }
  }

  // For non-California customers, check compliance data if countryCode is provided
  if (countryCode) {
    try {
      const compliancePayload = {
        conversationId,
        countryCode
      }
      
      const complianceResponse: any = await getComplianceData(compliancePayload)
      
   
      if (complianceResponse && complianceResponse?.data) {
        const responseData = complianceResponse?.data as BannerResponse
        console.log('complianceResponse', complianceResponse)
        return responseData
      }
      return {
        isCaliforniaCustomer: false,
        displayBanner: false,
        displayText: ''
      }
    } catch (error) {
      console.error('Error fetching compliance data:', error)
      return {
        isCaliforniaCustomer: false,
        displayBanner: false,
        displayText: ''
      }
    }
  }
  return {
    isCaliforniaCustomer: false,
    displayBanner: false,
    displayText: ''
  }

}

